import React from 'react'

import { useModal } from 'hooks'

// NOTE: hook that exposes edit evaluator modal state
// and handlers for other local hooks and interview components
export const useInviteEvaluatorModal = () => {
  const { handleClose, handleOpen, isOpen } = useModal()

  const handleConfirm = React.useCallback(() => {
    // TODO: pass proper api handler
  }, [])

  return {
    handleInviteEvaluatorClose: handleClose,
    handleInviteEvaluatorOpen: handleOpen,
    handleInviteEvaluatorConfirm: handleConfirm,
    isInviteEvaluatorOpen: isOpen,
  }
}
